import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Color, Label } from 'ng2-charts';
import { ChartDataSets, ChartOptions, ChartPoint } from 'chart.js';

@Component({
  selector: 'app-ph-chart',
  templateUrl: './ph-chart.component.html',
  styleUrls: ['./ph-chart.component.scss'],
})
export class PhChartComponent implements OnInit {
  @ViewChild('canvasChart', { static: true }) canvas: ElementRef;
  public lineChartData: ChartDataSets[] = [{ data: [] }];
  public lineChartLabels: Label[] = [];
  public lineChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: { display: false },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };
  public lineChartColors: Color[] = [];
  public lineChartLegend: boolean = true;
  public lineChartType: any = 'bar';
  public lineChartPlugins: any[] = [];

  constructor() {}

  ngOnInit() {
    const gradient = this.canvas.nativeElement.getContext('2d').createLinearGradient(0, 0, 0, 800);
    gradient.addColorStop(0, 'rgba(24, 160, 251, 0.3)');
    gradient.addColorStop(1, 'rgba(255,255,255,0)');
    this.lineChartColors = [
      {
        backgroundColor: gradient,
        borderColor: '#18A0FB',
        pointBorderWidth: 16,
        pointHoverBorderWidth: 16,
        pointBorderColor: 'rgba(255,255,255,0)',
        pointHoverBorderColor: '#18A0FB',
        pointBackgroundColor: '#18A0FB',
        pointHoverBackgroundColor: '#18A0FB',
      },
    ];
  }

  setData(data: number[] | ChartPoint[], label: Label[]) {
    this.lineChartData = [{ data }];
    this.lineChartLabels = label;
  }
}
